import { useRouter } from 'next/router'

interface TitleProps {
  job: any
  className?: string
  style?: React.CSSProperties
}

const JobTitle: React.FC<TitleProps> = (props: TitleProps) => {
	const { job, className, style }: any = props
	const router = useRouter()
	const locale: string = router.locale as string
	if (locale === 'sg') {
		return <h2 className={className} style={style}>{job.title}</h2>
	} else {
		if (locale === 'zh') {
			if (job.titleChinese !== null) {
				return <h2 className={className} style={style}>{job.titleChinese}</h2>
			} else {
				return <h2 className={className} style={style}>{job.title}</h2>
			}
		} else if (locale === 'my') {
			if (job.titleMalay !== null) {
				return <h2 className={className} style={style}>{job.titleMalay}</h2>
			} else {
				return <h2 className={className} style={style}>{job.title}</h2>
			}
		} else {
			return <h2 className={className} style={style}>{job.title}</h2>
		}
	}
}

export default JobTitle
